import React, { useState, useEffect, useContext } from "react";

import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";
import { useNavigate, useLocation } from "react-router-dom";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULES_QUERY } from "../graphQL/user_qry";
import {
  Container,
  Card,
  CardHeader,
  CardContent,
  Grid,
  Typography,
  Divider,
  Tooltip,
  Button,
  Link,
  List,
  ListSubheader,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";
import MenuHeader from "./MenuHeader.js";
import SideMenu from "../components/SideMenu.js";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

import { project_url } from "../constants/Data";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -45px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }
`;
const useStyles = makeStyles(theme => ({
  cardContainer: {
    marginLeft: "8rem",
    //  marginRight: "8rem",
    marginTop: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingRight: 10,
  },
  container: {
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    //  height: "936px",
    borderRadius: "8px",
  },
  expColIcon: {
    backgroundColor: "#fff",
    color: "#0D47A1",
    border: "1px solid lightGray",
    position: "absolute",
    width: 30,
    height: 30,
    "&:hover": {
      backgroundColor: "#1E88E5",
      color: "#fff",
      border: "none",
    },
  },
}));

var findAnd = require("find-and");

function TenantSideMenu({ selectedMenu, selectedSubMenu /*= "List"*/ }) {
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else navigate(`${project_url}/signin/?next=${pathname}`);
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`${project_url}/signin/?next=${pathname}`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin/?next=${pathname}`);
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
    }
  };

  const classes = useStyles();
  const location = useLocation();

  const menuList = [];

  let tenantUserId = 0;
  if (localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;
  if (localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 1;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");

  const [getStaffModules] = useManualQuery(STAFF_MODULES_QUERY, {
    fetchPolicy: "network-only",
  });

  const [tenantMenu, setTenantMenu] = useState([]);

  const getModules = async () => {
    //check if user is tennat admin display all menu

    if (isTenantAdmin == false) {
      // Get tenant information
      const {
        loading: satffModulesDataLoading,
        error: satffModulesDataError,
        data: satffModulesData,
      } = await getStaffModules({
        variables: {
          tenantUserId: parseInt(tenantUserId),
          clientId: parseInt(clientId),
        },
      });

      const temp = [
        {
          subheader: "Dashboard",
          icon: "Home",
          href: `${project_url}/tenant/dashboard`,
          items: [],
        },
      ];

      if (
        !satffModulesDataLoading &&
        satffModulesData &&
        satffModulesData.getStaffModules
      ) {
        for (var i in satffModulesData.getStaffModules) {
          let moduleName = satffModulesData.getStaffModules[i].module;
          let modulepages = satffModulesData.getStaffModules[i].modulepages.split(",");

          const findMenu = menuList.filter(e => e.moduleName === moduleName);

          if (findMenu.length === 0)
            menuList.push({ moduleName: moduleName, modulepages: modulepages });
        }

        //update menu
        if (menuList.filter(e => e.moduleName === "Clients").length !== 0) {
          let subMenuItem = menuList.find(a => a.moduleName == "Clients").modulepages;
          let items = [];
          if (subMenuItem.find(a => a == "List")) {
            items.push({
              title: "List",
              href: `${project_url}/clients`,
            });
          }
          temp.push({
            subheader: "Clients",
            icon: "Clients",
            items: items,
          });
        }

        if (menuList.filter(e => e.moduleName === "Forms").length !== 0) {
          let subMenuItem = menuList.find(a => a.moduleName == "Forms").modulepages;
          let items = [];
          if (subMenuItem.find(a => a == "List")) {
            items.push({
              title: "List",
              href: `${project_url}/forms`,
            });
          }
          temp.push({
            subheader: "Forms",
            icon: "Forms",
            items: items,
          });
        }

        if (menuList.filter(e => e.moduleName === "Terms").length !== 0) {
          let subMenuItem = menuList.find(a => a.moduleName == "Terms").modulepages;
          let items = [];
          if (subMenuItem.find(a => a == "List")) {
            items.push({
              title: "List",
              href: `${project_url}/terms`,
            });
          }
          temp.push({
            subheader: "Terms",
            icon: "Terms",
            items: items,
          });
        }

        if (menuList.filter(e => e.moduleName === "Teams").length !== 0) {
          let subMenuItem = menuList.find(a => a.moduleName == "Teams").modulepages;
          let items = [];
          if (subMenuItem.find(a => a == "List")) {
            items.push({
              title: "List",
              href: `${project_url}/teams`,
            });
          }
          temp.push({
            subheader: "Teams",
            icon: "Teams",
            items: items,
          });
        }

        if (menuList.filter(e => e.moduleName === "Members").length !== 0) {
          let subMenuItem = menuList.find(a => a.moduleName == "Members").modulepages;
          let items = [];
          if (subMenuItem.find(a => a == "List")) {
            items.push({
              title: "List",
              href: `${project_url}/members`,
            });
          }
          temp.push({
            subheader: "Members",
            icon: "Volunteers",
            items: items,
          });
        }

        if (menuList.filter(e => e.moduleName === "Sprints").length !== 0) {
          let subMenuItem = menuList.find(a => a.moduleName == "Sprints").modulepages;
          let items = [];
          if (subMenuItem.find(a => a == "List")) {
            items.push({
              title: "List",
              href: `${project_url}/sprints`,
            });
          }
          temp.push({
            subheader: "Sprints",
            icon: "Sprints",
            items: items,
          });
        }

        if (menuList.filter(e => e.moduleName === "Staff").length !== 0) {
          let subMenuItem = menuList.find(a => a.moduleName == "Staff").modulepages;
          let items = [];
          if (subMenuItem.find(a => a == "List")) {
            items.push({
              title: "List",
              href: `${project_url}/staff`,
            });
          }
          temp.push({
            subheader: "Staff",
            icon: "Staff",
            items: items,
          });
        }

        if (menuList.filter(e => e.moduleName === "Reports").length !== 0) {
          let subMenuItem = menuList.find(a => a.moduleName == "Reports").modulepages;
          let items = [];
          if (subMenuItem.find(a => a == "Download Applicants")) {
            items.push({
              title: "Download Applicants",
              href: `${project_url}/reports/download_applicants`,
            });
          }
          temp.push({
            subheader: "Reports",
            icon: "Reports",
            items: items,
          });
        }

        if (menuList.filter(e => e.moduleName === "General Settings").length !== 0) {
          let subMenuItem = menuList.find(
            a => a.moduleName == "General Settings",
          ).modulepages;
          let items = [];
          if (subMenuItem.find(a => a == "Configure Tenant")) {
            items.push({
              title: "Configure Tenant",
              href: `${project_url}/tenant/settings`,
            });
          }
          if (subMenuItem.find(a => a == "Configure Terms")) {
            items.push({
              title: "Configure Terms",
              href: `${project_url}/tenant/settings/term`,
            });
          }
          if (subMenuItem.find(a => a == "Manage Roles")) {
            items.push({
              title: "Manage Roles",
              href: `${project_url}/tenant/settings/roles`,
            });
          }
          if (subMenuItem.find(a => a == "Manage Event Types")) {
            items.push({
              title: "Manage Event Types",
              href: `${project_url}/tenant/settings/event_types`,
            });
          }
          if (subMenuItem.find(a => a == "Manage Term Templates")) {
            items.push({
              title: "Manage Term Templates",
              href: `${project_url}/tenant/settings/term_templates`,
            });
          }
          if (subMenuItem.find(a => a == "Manage Groups")) {
            items.push({
              title: "Manage Groups",
              href: `${project_url}/groups`,
            });
          }
          if (subMenuItem.find(a => a == "Manage Countries")) {
            items.push({
              title: "Manage Countries",
              href: `${project_url}/tenant/settings/countries`,
            });
          }
          if (subMenuItem.find(a => a == "Manage States")) {
            items.push({
              title: "Manage States",
              href: `${project_url}/tenant/settings/states`,
            });
          }
          temp.push({
            subheader: "General Settings",
            icon: "Settings",
            items: items,
          });
        }
      }

      setTenantMenu(temp);

      if (
        satffModulesDataError &&
        satffModulesDataError.graphQLErrors &&
        satffModulesDataError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    } else {
      const temp = [
        {
          subheader: "Dashboard",
          icon: "Home",
          href: `${project_url}/tenant/dashboard`,
          items: [],
        },

        {
          subheader: "Clients",
          icon: "Clients",
          items: [
            {
              title: "List",
              href: `${project_url}/clients`,
            },
          ],
        },

        {
          subheader: "Forms",
          icon: "Forms",
          items: [
            {
              title: "List",
              href: `${project_url}/forms`,
            },
          ],
        },
        {
          subheader: "Terms",
          icon: "Terms",
          items: [
            {
              title: "List",
              href: `${project_url}/terms`,
            },
          ],
        },

        {
          subheader: "Teams",
          icon: "Teams",
          items: [
            {
              title: "List",
              href: `${project_url}/teams`,
            },
          ],
        },
        {
          subheader: "Members",
          icon: "Volunteers",
          items: [
            {
              title: "List",
              href: `${project_url}/members`,
            },
          ],
        },

        {
          subheader: "Sprints",
          icon: "Sprints",
          items: [
            {
              title: "List",
              href: `${project_url}/sprints`,
            },
          ],
        },

        {
          subheader: "Staff",
          icon: "Staff",
          items: [
            {
              title: "List",
              href: `${project_url}/staff`,
            },
          ],
        },

        {
          subheader: "Reports",
          icon: "Reports",
          items: [
            {
              title: "Download Applicants",
              href: `${project_url}/reports/download_applicants`,
            },
          ],
        },

        {
          subheader: "General Settings",
          icon: "Settings",
          items: [
            {
              title: "Configure Tenant",
              href: `${project_url}/tenant/settings`,
            },
            {
              title: "Configure Terms",
              href: `${project_url}/tenant/settings/term`,
            },
            {
              title: "Manage Roles",
              href: `${project_url}/tenant/settings/roles`,
            },
            {
              title: "Manage Event Types",
              href: `${project_url}/tenant/settings/event_types`,
            },
            {
              title: "Manage Term Templates",
              href: `${project_url}/tenant/settings/term_templates`,
            },
            {
              title: "Manage Groups",
              href: `${project_url}/groups`,
            },
            {
              title: "Manage Countries",
              href: `${project_url}/tenant/settings/countries`,
            },
            {
              title: "Manage States",
              href: `${project_url}/tenant/settings/states`,
            },
          ],
        },
      ];

      setTenantMenu(temp);
    }
  };

  const [menuStatus, setMenuStatus] = useState({
    simple: selectedMenu ? selectedMenu : "Dashboard",
    expand: null,
  });

  const [subMenu, setSubMenu] = useState({
    menu: selectedMenu,
    sub: selectedSubMenu,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getModules())();
    
  }, []);

  useEffect(() => {
    if (
      location.pathname.indexOf(`${project_url}/tenant/settings`) != -1 &&
      location.pathname.indexOf(`${project_url}/groups`) === -1 &&
      location.pathname.indexOf(`${project_url}/tenant/settings/countries`) === -1 &&
      location.pathname.indexOf(`${project_url}/tenant/settings/states`) === -1 &&
      location.pathname.indexOf(`${project_url}/tenant/settings/roles`) === -1 &&
      location.pathname.indexOf(`${project_url}/tenant/settings/event_types`) === -1 &&
      location.pathname.indexOf(`${project_url}/tenant/settings/term`) === -1
    ) {
      setMenuStatus({
        simple: "General Settings",
        expand: null,
      });
      setSubMenu({
        menu: "General Settings",
        sub: "Configure Tenant",
      });
    } else if (
      location.pathname.indexOf(`${project_url}/tenant/dashboard`) != -1 ||
      location.pathname.indexOf(`${project_url}/profile/`) != -1
    ) {
      setMenuStatus({
        simple: "Dashboard",
        expand: null,
      });
      setSubMenu({
        menu: "Dashboard",
        sub: null,
      });
    }
  }, [location]);

  return (
    <div
      className={classes.cardContainer}
      //style={{ marginRight: simple ? "8rem" : "1rem" }}
    >
      <div className={classes.container}>
        <Card
          style={{
            width: menuStatus.simple ? 100 : 280,
            minHeight: 936,
          }}
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <Box pt={0} style={{ width: menuStatus.expand ? "93%" : "80%" }}>
              {tenantMenu.map(menu => (
                <SideMenu
                  subheader={menu.subheader}
                  items={menu.items}
                  href={menu.href}
                  icon={menu.icon}
                  menuStatus={menuStatus}
                  subMenu={subMenu}
                  menuStatusFunc={item => setMenuStatus(item)}
                  subMenuFunc={item => setSubMenu(item)}
                />
              ))}
            </Box>
            <Box pt={3}>
              <IconButton className={classes.expColIcon}>
                {menuStatus.simple && (
                  <StyledTooltip title="Expand menu">
                    <KeyboardArrowRightIcon
                      onClick={() => {
                        setMenuStatus({
                          simple: null,
                          expand: menuStatus.simple,
                        });
                      }}
                    />
                  </StyledTooltip>
                )}
                {menuStatus.expand && (
                  <StyledTooltip title="Collapse menu">
                    <KeyboardArrowLeftIcon
                      onClick={() => {
                        if (subMenu.menu === menuStatus.expand)
                          setMenuStatus({ simple: menuStatus.expand, expand: null });
                        else setMenuStatus({ simple: subMenu.menu, expand: null });
                      }}
                    />
                  </StyledTooltip>
                )}
              </IconButton>
            </Box>
          </Box>
        </Card>
      </div>
    </div>
  );
}

export default TenantSideMenu;
